import Vue from 'vue';

export default {
  state: {
    estatePage: {
      content: '',
    },
  },
  mutations: {
    setEstatePage(state, data) {
      state.estatePage = data;
    },
  },
  actions: {
    getEstatePage(store) {
      const path = 'estate';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setEstatePage', resp.data);
        return resp.data;
      });
    },
  },
};
